<template>
  <div class="detail">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoSy">首页></span>
        <span @click="GoDj">党纪法规></span>
        <span @click="GoXts">小贴士></span>
        <span class="red">正文</span>
      </div>
    </div>
    <!-- 正文 -->
    <div class="zhengwen">
      <h1>中央纪委国家监委办公厅印发通知做好政务处分法实施工作</h1>
      <div class="first">
        <span class="third">来源：新华社</span>
        <span>发布时间：2020-5-20 13:30</span>
      </div>
      <div class="xh"></div>
      <div class="second">
        <p>
          6月20日，第十三届全国人民代表大会常务委员会第十九次会议通过了《中华人民共和国公职人员政务处分法》（以下简称《政务处分法》），自2020年7月1日起施行。为推动纪检监察系统做好《政务处分法》实施工作，提高政务处分工作规范化、法治化水平，中央纪委办公厅、国家监委办公厅于近日专门印发了有关通知。
        </p>

        <p>
          通知强调，要充分认识制定《政务处分法》的意义。《政务处分法》深入贯彻习近平新时代中国特色社会主义思想，认真落实党的十九大和十九届二中、三中、四中全会精神，是在新的起点上深化纪检监察体制改革，坚持和完善党和国家监督体系，推进国家治理体系和治理能力现代化的重要制度成果。《政务处分法》作为新中国成立以来第一部全面系统规范公职人员政务处分工作的国家法律，将监察全覆盖的要求进一步具体化，使政务处分匹配党纪处分、衔接刑事处罚，构筑起惩治职务违法的严密法网，对于健全反腐败国家立法，强化对权力运行的制约和监督，构建一体推进不敢腐、不能腐、不想腐体制机制具有重要意义。
        </p>

        <p>
          通知指出，要准确把握《政务处分法》的要求，依法精准做好政务处分工作。各级纪检监察机关要充分发挥合署办公优势，实现执纪执法贯通，促进党内监督和国家监察有机统一。要积极协助党委（党组）落实全面从严治党主体责任，促进任免机关、单位加强对所管公职人员的教育、管理、监督，依法履行处分职责，推动主体责任和监督责任一贯到底。要以“三不”一体理念思路推进正风肃纪反腐，加强对公职人员的日常监督，促进抓早抓小、防微杜渐，对公职人员违法行为依法查处、严肃追责，深入促进以案促改，持续深化标本兼治。要牢固树立法治意识、程序意识、证据意识，严格按照法定程序开展政务处分工作，坚持集体讨论决定，切实保障公职人员依法行使申辩权、申请回避权、申请复审复核权等各项权利，严禁非法收集证据。
        </p>

        <p>
          通知要求，要采取有力措施，抓好《政务处分法》实施工作。各级纪检监察机关要充分发挥职能作用，协助同级党委（党组）抓好本地区本部门本单位的宣传教育和执行落实。通过广泛深入的宣传教育，使广大公职人员牢记手中的权力是党和人民赋予的，只能用来为人民谋利益，使法律要求真正转化为公职人员的日常习惯和自觉遵循。各级纪检监察机关和广大纪检监察干部要做严格遵纪守法的模范，在强化自我约束、接受监督制约上作表率，确保政务处分权严格依法、公正行使。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    Gohome() {
      this.$router.push("/");
    },
  },
};
</script>
<style lang="less" scoped>
.detail {
  width: 1200px;
  margin: 0 auto;
}
.container {
  width: 1200px;
  margin: 0 auto;
}
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
.zhengwen {
  width: 1200px;
  background-color: white;
  padding: 60px;
  box-sizing: border-box;
}
p {
  text-indent: 2em;
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
}
p:nth-child(1) {
  text-indent: 0;
}
h1 {
  text-align: center;
  font-size: 28px;
  color: #333333;
}
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}
.daohang {
  margin: 20px 0;
}
.third {
  margin-right: 20px;
}
</style>
